import _extends from "@babel/runtime/helpers/extends";
import { AutoComplete, Box, FormField, listItemSelectBuilder } from '@wix/design-system';
import React from 'react';
import { RuleListStatus } from '../../../types';
import { dataHooks } from '../../../utils/datahooks';
import { RuleFooter, RuleLayout } from '../../rule-layout';
import { DropdownFixerCompletedState } from './dropdown-fixer-completed-state';
import { useDropdownFixer } from './use-dropdown-fixer';
import { includesCaseInsensitive } from './utils';
export const DropdownFixer = _ref => {
  let {
    ruleResult,
    selected
  } = _ref;
  const {
    ruleFooterProps,
    value,
    tips,
    onSelectValue,
    description,
    options,
    searchValue,
    setSearchValue,
    fieldLabel,
    isEditMode,
    onEditClick,
    onClick
  } = useDropdownFixer(ruleResult, selected);
  const design = ruleResult.fixerProps.design;
  const optionsForAutoComplete = options.map(_ref2 => {
    let {
      id,
      value: title
    } = _ref2;
    return listItemSelectBuilder({
      id,
      label: title,
      size: 'small',
      title
    });
  });
  return ruleResult.status === RuleListStatus.passed && !isEditMode ? /*#__PURE__*/React.createElement(DropdownFixerCompletedState, {
    dataHook: ruleResult.dataHook,
    description: description,
    key: ruleResult.id,
    ruleResult: ruleResult,
    onEditClick: onEditClick
  }) : /*#__PURE__*/React.createElement(RuleLayout, {
    description: description,
    design: design == null ? void 0 : design.ruleLayout
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: (design == null ? void 0 : design.formGap) ?? 'SP1'
  }, /*#__PURE__*/React.createElement(FormField, {
    dataHook: dataHooks.formFieldDropdownFixer(ruleResult.dataHook),
    label: fieldLabel,
    labelSize: "tiny"
  }, /*#__PURE__*/React.createElement(AutoComplete, {
    dataHook: dataHooks.autoCompleteFieldDropdownFixer(ruleResult.dataHook),
    disabled: ruleFooterProps.submitButtonProps.showLoader,
    options: optionsForAutoComplete,
    predicate: option => includesCaseInsensitive(option.label, searchValue.trim()),
    selectedId: value == null ? void 0 : value.id,
    size: "small",
    value: searchValue,
    onChange: event => setSearchValue(event.target.value),
    onOptionsShow: onClick,
    onSelect: option => {
      onSelectValue({
        id: option.id,
        value: option.label
      });
    }
  })), tips), /*#__PURE__*/React.createElement(RuleFooter, _extends({
    dataHook: ruleResult.dataHook
  }, ruleFooterProps, {
    design: design == null ? void 0 : design.ruleFooter,
    submitButtonProps: {
      ...ruleFooterProps.submitButtonProps
    }
  })));
};
//# sourceMappingURL=dropdown-fixer.js.map